import React, { Component } from 'react'

import Showdown from 'showdown'
import InView from '../../containers/SectionWrapper.jsx'

class Quote extends Component {
    render() {

        const converter = new Showdown.Converter()
        const { text } = this.props

        return (

            <div className="ptlg pblg xs-ptsm xs-pbsm">

                <div className="grid">

                    <div className="unit whole">
                        
                        <InView onChange={this.onChange} threshold={0.25}>
                            <blockquote dangerouslySetInnerHTML={{ __html: converter.makeHtml(text) }} />
                        </InView>
                    

                    </div>

                </div>

            </div>

        );
    }
}


export default Quote;